document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('#product-stories-root');
  if (!root) return;

  const floatingWrapper = root.querySelector('.stories-floating-wrapper');
  const btnFloating = root.querySelector('#stories-floating-button');
  const closeFloatingBtn = root.querySelector('#stories-floating-close');
  const overlay = root.querySelector('#stories-overlay');
  const closeBtn = root.querySelector('.stories-close');
  const addToCartBtn = root.querySelector('.stories-add-to-cart-btn');

  const shell =
    (overlay && overlay.querySelector('.stories-shell')) ||
    root.querySelector('.stories-shell');

  const video =
    (overlay && overlay.querySelector('.story-video')) ||
    root.querySelector('.story-video');

  const variantSelect =
    (overlay && overlay.querySelector('.stories-variant-select')) ||
    root.querySelector('.stories-variant-select');

  const swatches =
    (overlay && overlay.querySelectorAll('.stories-variant-swatch')) ||
    root.querySelectorAll('.stories-variant-swatch');

  const currentVariantName =
    (overlay && overlay.querySelector('.stories-variant-current-name')) ||
    root.querySelector('.stories-variant-current-name');

  const playToggleBtn =
    (overlay && overlay.querySelector('.stories-play-toggle')) ||
    root.querySelector('.stories-play-toggle');

  const productId = root.dataset.productId;
  const videoUrl = root.dataset.videoUrl;

  /* -----------------------------
     Cart badge
     ----------------------------- */
  function updateCartBadge() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((res) => res.json())
      .then((cart) => {
        const counters = document.querySelectorAll(
          '[data-cart-count], .cart-count-badge, .header-cart__count, .cart-count, .cart-link__count'
        );

        if (counters.length) {
          counters.forEach((el) => {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) {
              el.classList.add('is-visible');
            } else {
              el.classList.remove('is-visible');
            }
          });
        } else {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.error('Erro ao atualizar ícone do carrinho', err);
      });
  }

  /* -----------------------------
     Video URL
     ----------------------------- */
  if (video && videoUrl) {
    const source = video.querySelector('source');
    if (source) {
      source.src = videoUrl;
    } else {
      video.src = videoUrl;
    }
    video.load();
  }

  /* -----------------------------
     Play / Pause
     ----------------------------- */
  function syncPlayState() {
    if (shell && video) {
      if (video.paused) {
        shell.classList.add('is-paused');
      } else {
        shell.classList.remove('is-paused');
      }
    }
    if (playToggleBtn && video) {
      playToggleBtn.textContent = video.paused ? '▶' : '❚❚';
    }
  }

  if (playToggleBtn && video) {
    playToggleBtn.addEventListener('click', function () {
      if (video.paused) {
        video
          .play()
          .then(syncPlayState)
          .catch(syncPlayState);
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', syncPlayState);
    video.addEventListener('pause', syncPlayState);
    video.addEventListener('ended', syncPlayState);
  }

  /* -----------------------------
     Variants
     ----------------------------- */
  function setActiveVariant(variantId, variantTitle) {
    if (!variantId) return;
    const idStr = String(variantId);

    if (variantSelect) {
      variantSelect.value = idStr;
    }

    if (addToCartBtn) {
      addToCartBtn.dataset.variantId = idStr;
    }

    if (currentVariantName && variantTitle) {
      currentVariantName.textContent = variantTitle;
    }

    if (swatches && swatches.length) {
      swatches.forEach(function (btn) {
        if (btn.dataset.variantId === idStr) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    }
  }

  if (variantSelect) {
    const initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) {
      setActiveVariant(initialOption.value, initialOption.text);
    }

    variantSelect.addEventListener('change', function () {
      const opt = this.options[this.selectedIndex];
      setActiveVariant(this.value, opt ? opt.text : '');
    });
  } else if (addToCartBtn && productId) {
    addToCartBtn.dataset.variantId = productId;
  }

  if (swatches && swatches.length) {
    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const vId = this.dataset.variantId;
        const vTitle = this.dataset.variantTitle || '';
        setActiveVariant(vId, vTitle);
      });
    });
  }

  /* -----------------------------
     Overlay open/close
     ----------------------------- */
  function openStories() {
    if (!overlay) return;
    overlay.classList.remove('stories-hidden');
    document.documentElement.classList.add('stories-open');
    document.body.classList.add('stories-open');

    if (video) {
      video.muted = false;
      video.currentTime = 0;
      video
        .play()
        .then(syncPlayState)
        .catch(syncPlayState);
    }
  }

  function closeStories() {
    if (!overlay) return;
    overlay.classList.add('stories-hidden');
    document.documentElement.classList.remove('stories-open');
    document.body.classList.remove('stories-open');

    if (video) {
      video.pause();
    }
    syncPlayState();
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeStories);
  }

  if (overlay) {
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closeStories();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeStories();
    }
  });

  /* -----------------------------
     Floating widget: drag (wrapper)
     ----------------------------- */
  if (floatingWrapper && btnFloating) {
    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let startLeft = 0;
    let startTop = 0;
    let dragStartedOnBtn = false;
    const DRAG_THRESHOLD = 8;

    function pointerDown(e) {
      const target = e.target;

      // Se clicou no X, deixa o handler do X cuidar
      if (closeFloatingBtn && (target === closeFloatingBtn || closeFloatingBtn.contains(target))) {
        return;
      }

      const evt = e.touches ? e.touches[0] : e;

      dragStartedOnBtn = btnFloating.contains(target);
      isDragging = false;
      dragStartX = evt.clientX;
      dragStartY = evt.clientY;

      const rect = floatingWrapper.getBoundingClientRect();
      startLeft = rect.left;
      startTop = rect.top;

      floatingWrapper.style.bottom = 'auto';
      floatingWrapper.style.right = 'auto';
      floatingWrapper.style.left = `${startLeft}px`;
      floatingWrapper.style.top = `${startTop}px`;

      window.addEventListener('mousemove', pointerMove);
      window.addEventListener('mouseup', pointerUp);
      window.addEventListener('touchmove', pointerMove, { passive: false });
      window.addEventListener('touchend', pointerUp);
    }

    function pointerMove(e) {
      const evt = e.touches ? e.touches[0] : e;

      const dx = evt.clientX - dragStartX;
      const dy = evt.clientY - dragStartY;

      if (!isDragging && Math.hypot(dx, dy) > DRAG_THRESHOLD) {
        isDragging = true;
      }

      if (!isDragging) return;

      if (e.cancelable) e.preventDefault();

      const btnWidth = floatingWrapper.offsetWidth;
      const btnHeight = floatingWrapper.offsetHeight;

      let newLeft = startLeft + dx;
      let newTop = startTop + dy;

      const margin = 8;
      const maxLeft = window.innerWidth - btnWidth - margin;
      const maxTop = window.innerHeight - btnHeight - margin;

      if (newLeft < margin) newLeft = margin;
      if (newTop < margin) newTop = margin;
      if (newLeft > maxLeft) newLeft = maxLeft;
      if (newTop > maxTop) newTop = maxTop;

      floatingWrapper.style.left = `${newLeft}px`;
      floatingWrapper.style.top = `${newTop}px`;
    }

    function pointerUp() {
      window.removeEventListener('mousemove', pointerMove);
      window.removeEventListener('mouseup', pointerUp);
      window.removeEventListener('touchmove', pointerMove);
      window.removeEventListener('touchend', pointerUp);

      // Clique rápido na bolinha abre o stories
      if (!isDragging && dragStartedOnBtn) {
        openStories();
      }

      isDragging = false;
      dragStartedOnBtn = false;
    }

    floatingWrapper.addEventListener('mousedown', pointerDown);
    floatingWrapper.addEventListener('touchstart', pointerDown, { passive: true });
  }

  /* -----------------------------
     Botão X: esconde widget
     ----------------------------- */
  if (closeFloatingBtn) {
    closeFloatingBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (floatingWrapper) {
        floatingWrapper.style.display = 'none';
      }
    });
  }

  /* -----------------------------
     Add to cart
     ----------------------------- */
  if (addToCartBtn && productId) {
    addToCartBtn.addEventListener('click', function () {
      const variantId = this.dataset.variantId || productId;
      const btn = this;

      if (!variantId) return;

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
        .then((res) => res.json())
        .then(() => {
          btn.textContent = 'Adicionado!';
          setTimeout(function () {
            btn.textContent = 'Adicionar ao carrinho';
            btn.disabled = false;
          }, 2000);

          updateCartBadge();

          document.dispatchEvent(
            new CustomEvent('product:added', { detail: { variantId } })
          );
        })
        .catch((err) => {
          console.error('Erro ao adicionar ao carrinho', err);
          btn.disabled = false;
        });
    });
  }
});

// ===============================
// PROGRESS BAR + LOOP DO VÍDEO
// ===============================

(function () {
  var root = document.querySelector('.product-stories-root');
  if (!root) return;

  var storyVideo = root.querySelector('.story-video');
  var progressFill = root.querySelector('.stories-progress-fill');

  if (!storyVideo || !progressFill) return;

  function resetProgress() {
    progressFill.style.width = '0%';
  }

  function updateProgress() {
    if (!storyVideo.duration || isNaN(storyVideo.duration)) return;

    var pct = (storyVideo.currentTime / storyVideo.duration) * 100;
    progressFill.style.width = pct + '%';
  }

  // Quando o vídeo carrega, já atualiza (caso comece do meio)
  storyVideo.addEventListener('loadedmetadata', updateProgress);
  storyVideo.addEventListener('timeupdate', updateProgress);

  // Loop automático: ao terminar, volta pro início e toca de novo
  storyVideo.addEventListener('ended', function () {
    resetProgress();
    storyVideo.currentTime = 0;
    storyVideo.play().catch(function () {
      // se o navegador bloquear autoplay, pelo menos a barra volta pro zero
    });
  });

  // Deixar acessível globalmente caso precise resetar ao fechar
  window.__productStoriesResetProgress = resetProgress;
})();
